<template>
  <div class="ibox">
			<a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
				Show Filters <i class="fa fa-bars"></i>
			</a>
			<div class="ibox-results-filters-collapse-box collapse in">
				<div class="ibox-results-filters">
					<div class="row">
            <div class="col-sm-6 col-lg-3" v-if="$user.isAdminOrCoordinator">
							<div class="form-group">
								<label class="control-label">Client</label>
                <selectize :options="initialUserOptions" v-model="user_id" name="user" :fetch-results="fetchUserResults"></selectize>
							</div>
						</div>
						<div class="col-sm-6 col-lg-3">
							<div class="form-group">
								<label class="control-label">Keywords</label>
                <input type="text" class="form-control" placeholder="..." @input="updateKeywords" />
							</div>
						</div>
						<div class="col-sm-6 col-lg-3">
							<div class="form-group">
								<label class="control-label">Status</label>
                <selectize :options="statusOptions" v-model="status" name="status"></selectize>

							</div>
						</div>
						<div class="col-sm-6 col-lg-3">
							<div class="form-group">
								<label class="control-label">Date Range</label>
                <date-range v-model="dateRange" name="date_range"></date-range>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="ibox-content">
        <ul class="list-detail list-detail-invoice">
          <invoice-item v-for="invoice in invoices" :key="invoice.id" :invoice="invoice"></invoice-item>
        </ul>
        <div class="text-center text-muted" v-show="haveNoInvoices">
          <strong>There are no invoices.</strong>
        </div>
			</div>
      <lazy-loading v-show="haveInvoices" :reached-bottom="getInvoicesForNextPage" :filters="filters" ref="lazyLoading">
        <strong slot="finished" class="text-muted">There are no more invoices.</strong>
      </lazy-loading>

		</div>
</template>

<script>
  import { LazyLoading } from 'components/misc'
  import { debounce, isEqual, cloneDeep } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { Roles } from 'utils/user'
  import { Selectize, DateRange } from 'components/forms'
  import InvoiceItem from './InvoiceItem'

  export default {
    components: {
      LazyLoading,
      InvoiceItem,
      Selectize,
      DateRange
    },

    data () {
      return {
        initialUserOptions: [],
        keywords: '',
        status: 'all',
        user_id: null,
        dateRange: {
          from: null,
          to: null
        }
      }
    },

    watch: {
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          // Reset the lazy loading component so that it will attempt to load
          // more jobs as we scroll again.
          const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))
          this.getInvoices(this.filters).then(resetLazyLoading)
        },
        deep: true
      }
    },

    computed: {
      ...mapGetters('invoice', { 'invoices': 'invoicesDecorated' }),
      ...mapGetters('user', ['userOptionsWithAll']),

      filters () {
        return {
          keywords: this.keywords,
          status: this.status,
          from: this.dateRange.from,
          to: this.dateRange.to,
          user_id: this.user_id
        }
      },

      statusOptions () {
        return [
          { id: 'all', text: 'All' },
          { id: 'current', text: 'Current' },
          { id: 'paid', text: 'Paid' },
          { id: 'overdue', text: 'Overdue' }
        ]
      },

      haveInvoices () {
        return this.invoices.length > 0
      },

      haveNoInvoices () {
        return this.invoices.length === 0
      }
    },

    created () {
      this.getInvoices(this.filters)

      if (this.$user.isAdminOrCoordinator) {
        const setInitialUserOptions = () => (this.initialUserOptions = cloneDeep(this.userOptionsWithAll))

        this.getUsers({ roles: [Roles.ADMIN, Roles.COORDINATOR, Roles.CLIENT, Roles.CARRIER], master: true }).then(setInitialUserOptions)
      }
    },

    methods: {
      ...mapActions('invoice', ['getInvoices', 'getInvoicesForNextPage']),
      ...mapActions('user', ['getUsers']),

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchUserResults (name, callback) {
        return this.getUsers({ roles: [Roles.ADMIN, Roles.COORDINATOR, Roles.CLIENT, Roles.CARRIER], name, master: true }).then(response => {
          callback(this.userOptionsWithAll)
        })
      },

      /**
       * Debounce updating of keywords so we don't poll API immediately for new invoices.
       *
       * @param object event
       *
       * @return Function
       */
      updateKeywords: debounce(function (event) {
        this.keywords = event.target.value
      }, 800)
    }
  }
</script>



// WEBPACK FOOTER //
// Invoices.vue?1c66ad92